/*
 * 本文件存放【具体业务功能】公共函数
 * 服务于具体业务场景
 */

import axios from "axios";
import { cookies } from "./..//cookieUtils";
const baseURL = require("@/config/APIs").API;
import { Message, Notice } from "iview";
let tenant_id = localStorage.getItem("tenant")
  ? JSON.parse(localStorage.getItem("tenant")).id
  : "";
let project_id = localStorage.getItem("project")
  ? JSON.parse(localStorage.getItem("project")).id
  : "";
// 下载文件函数
const exportFile = (filePath, params, fileName) => {
  cookies.getAuthorization().then(token => {
    const config = {
      baseURL: baseURL,
      timeout: 60000,
      params: params,
      headers: {
        Pragma: "no-cache",
        "Content-type": "application/json;charset=UTF-8",
        "X-Auth-Token": token || null,
        "X-Auth-Tenant": tenant_id || "",
        "X-Auth-Project": project_id || "",
        "Accept-Language": localStorage.getItem("local") || navigator.language
      },
      responseType: "blob"
    };
    axios
      .get(filePath, config)
      .then(res => {
        let content = res.data;
        let blob = new Blob([content]);

        if ("msSaveOrOpenBlob" in navigator) {
          // Microsoft Edge and Microsoft Internet Explorer 10-11
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          if ("download" in document.createElement("a")) {
            // 非IE下载
            let elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveOrOpenBlob(blob, fileName);
          }
        }
      })
      .catch(err => {
        let data = err.response.data;
        if (err.request.responseType === "blob") {
          var reader = new FileReader();
          reader.readAsText(data, "utf-8");
          reader.onload = function() {
            data = JSON.parse(reader.result);
            Message.error({
              content: data.description,
              duration: 5,
              closable: true
            });
          };
        } else {
          Message.error({
            content: err,
            duration: 5,
            closable: true
          });
        }
      });
  });
};

// 上传文件函数
const uploadFile = (filePath, data, timeout) => {
  return cookies.getAuthorization().then(token => {
    const config = {
      baseURL: baseURL,
      timeout: timeout ? timeout : 60000,
      headers: {
        Pragma: "no-cache",
        "Content-type": "multipart/form-data",
        "X-Auth-Token": token || null,
        "X-Auth-Tenant": tenant_id || "",
        "X-Auth-Project": project_id || ""
      }
    };
    return axios.post(filePath, data, config).then(
      res => {
        return res.data;
      },
      err => {
        Notice.error({
          title: err.response.data.title,
          desc: err.response.data.description,
          duration: 15
        });
        return err;
      }
    );
  });
};

// 消抖函数
const debounce = function(callback, delay, immediate) {
  let timeout, result;
  return function() {
    let context = this;
    let args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) result = callback.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, delay);
    if (callNow) result = callback.apply(context, args);
    return result;
  };
};
// 节流函数
const throttle = function(fn, delay) {
  let timer = null;
  let remaining = 0;
  let previous = new Date();
  return function() {
    let now = new Date();
    remaining = now - previous;
    let args = arguments;
    let context = this;
    if (remaining >= delay) {
      if (timer) {
        clearTimeout(timer);
      }
      fn.apply(context, args);
      previous = now;
    } else {
      if (!timer) {
        timer = setTimeout(function() {
          fn.apply(context, args);
        }, delay - remaining);
      }
    }
  };
};

const getURLiot = function(path) {
  /***测试环境域名关键字 'localhost','sit','dev', 'uat'*/
  let testENV = ["localhost", "sit", "dev", "uat"].find(item =>
    location.hostname.includes(item)
  );
  let url = "http://cloud.iot.cmft.com/oes/";
  if (testENV) {
    //测试环境都跳物联网的测试环境
    url = "http://cloud.iot.sit.cmft.com/oes/";
  }
  return url + path;
};
//跳转登录页
export const login = ()=>{
  const url = getCloudUrl(`login?redirect_url=${encodeURIComponent(location.href)}`);
  location.replace(url);
}

//获取招商云的地址
const getCloudUrl = function(path) {
  /***测试环境域名关键字 'localhost','sit','dev', 'uat'*/
  let testENV = ["localhost", "sit", "dev", "uat"].find(item =>
    location.hostname.includes(item)
  );
  let url = "http://cloud.cmft.com/";
  //let url = "http://cloud.sit.cmft.com/";
  if (testENV) {
    //测试环境都跳招商云的测试环境
    url = "http://cloud.sit.cmft.com/";
  }
  return `${url}#${path}`;
};
export default {
  exportFile,
  uploadFile,
  debounce,
  throttle,
  getURLiot,
  getCloudUrl,
  login
};



// WEBPACK FOOTER //
// ./src/common/js/publicMethod.js